<template>
  <div>
    <h3 class="student-subaccount-box--title mb-3">
      {{ $t('archivedClasses') }}
    </h3>

    <v-data-table :headers="headersTitles" :items="items" class="elevation-1" :items-per-page="limit" item-key="id"
      :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50, 100],
        }" @update:options="onPageChange">
      <template v-slot:item.action="{ item }">
        <button class="btn-round add-student-btn" type="button" v-on:click="viewRecording(item.number)">
          {{ $t('viewClass') }}
        </button>
      </template>
    </v-data-table>

    <div class="modal fade" id="videoModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Recording Preview</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              v-on:click="currentVideoUrl = null"></button>
          </div>
          <div class="modal-body">
            <video width="100%" controls controlsList="nodownload" autoplay class="video-container" id="videoContainer"
              :key="currentVideoUrl">
              <source v-bind:src="currentVideoUrl" type="video/mp4">
              Your browser does not support HTML video.
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
export default {
  mixins: [GlobalMixin],
  data() {
    return {
      items: [
      ],
      dataBody: {},
      limit: 10,
      pages: null,
      page: 1,
      pageSize: 2,
      currentVideoUrl: null
    }
  },
  methods: {
    viewRecording(sessionId) {
      this.axios.get(`${process.env.VUE_APP_APIEndPoint}reserve/sessions/${sessionId}/`, this.headers)
        .then((res) => {
          if (!res.data.data.record_public_url || res.data.data.record_public_url === "") {
            this.notify(this.$t('recordNotAvailable'), 'error');
          } else {
            this.currentVideoUrl = atob(res.data.data.record_public_url);
            $('#videoModal').modal('show');
          }
        }).catch((error) => {
          let errors = '';
          error.response.data.errors.forEach((value, index) => {
            for (error in value) {
              errors += `<li>${value[error]}</li>`;
            }
          });
          Swal.fire({
            icon: 'error',
            html: errors,
          })
        });
    },
    async onPageChange({ page }) {
      this.ShowLoading();
      try {
        this.dataBody.session_offset = (page - 1) * this.limit ?? 0;
        this.dataBody.session_limit = this.limit;
        this.dataBody.webinar_offset = (page - 1) * this.limit ?? 0;
        this.dataBody.webinar_limit = this.limit;
        await this.getRecordings();
      } finally {
        this.HideLoading();
      }
    },
    getRecordings() {
      this.axios.post(`${process.env.VUE_APP_APIEndPoint}reserve/sessions-webinars-list/`, this.dataBody, this.headers)
        .then((res) => {
          this.pages = Math.ceil(res.data.data.sessions_pagination_data.count / res.data.data.sessions_pagination_data.limit);
          this.items = res.data.data.upcoming_sessions.map(session => {
            return {
              number: session.session_id,
              date: session.start_date,
              tutorName: `${session.tutor.first_name} ${session.tutor.last_name}`,
              courseType: session.course_type,
              program: session.program.name,
              costusd: session.session_fee,
            }
          });
        }).catch((error) => {
          let errors = '';
          error.response.data.errors.forEach((value, index) => {
            for (error in value) {
              errors += `<li>${value[error]}</li>`;
            }
          });
          Swal.fire({
            icon: 'error',
            html: errors,
          })
        });
    }
  },
  computed: {
    headersTitles() {
      return [
        { text: "#", value: "number", sortable: false },
        { text: this.$t("Date"), value: "date", sortable: false },
        { text: this.$t("tutorName"), value: "tutorName", sortable: false },
        { text: this.$t("Course Type"), value: "courseType", sortable: false },
        { text: this.$t("Program"), value: "program", sortable: false },
        { text: this.$t("totalCost"), value: "costusd", sortable: false },
        { text: this.$t("Action"), value: "action", sortable: false }
      ]
    }
  }
}

</script>
<style scoped lang="scss">
.video-container {
  width: 100%;
}
</style>
<style>
video {

  width: 100%;
}
</style>